import { createSlice } from '@reduxjs/toolkit';
const defaultState = {
    questionsCount: 0,
    currentQuestionNumber: 0,
    currentAnswerStatus: false,
    totalScore: 0,
    component: '',
    audioDefault: false,
};
const sessionStatus = createSlice({
    name: 'sessionStatus',
    initialState: defaultState,
    reducers: {
        setCurrentAnswerStatus: (state, action) => {
            return { ...state, currentAnswerStatus: action.payload };
        },
        setQuestionsCount: (state, action) => {
            return { ...state, questionsCount: action.payload };
        },
        setNextQuestion: (state) => {
            return {
                ...state,
                currentQuestionNumber: state.currentQuestionNumber + 1,
            };
        },
        changeTotalScore: (state, action) => {
            return {
                ...state,
                totalScore: state.totalScore + action.payload,
            };
        },
        setComponent: (state, action) => {
            return { ...state, component: action.payload };
        },
        setAudioDefaultState: (state, action) => {
            return {
                ...state,
                audioDefault: action.payload,
            };
        },

        setDefaultState: () => {
            return defaultState;
        },
    },
});

export const {
    setCurrentAnswerStatus,
    setQuestionsCount,
    setNextQuestion,
    changeTotalScore,
    setDefaultState,
    setComponent,
    setAudioDefaultState,
} = sessionStatus.actions;

export default sessionStatus.reducer;
